package ru.villawonka.app.presentation.screens.search.compose.view

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Colors
import androidx.compose.material.ExperimentalMaterialApi
import androidx.compose.material.Icon
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.ui.tooling.preview.Preview
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppColors
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.AppTheme
import ru.villawonka.app.presentation.screens.search.model.SortTypeUIModel
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_sort_24

@OptIn(ExperimentalMaterialApi::class)
@Composable
fun SortButton(
    sortType: SortTypeUIModel,
    onClickListener: (() -> Unit)? = null,
) {
    val contentColor = MaterialTheme.colors.filledSortContentFocused
    val backgroundColor = MaterialTheme.colors.filledSortBackgroundFocused

    Surface(
        color = backgroundColor,
        shape = RoundedCornerShape(12.dp),
        onClick = { onClickListener?.invoke() },
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .padding(
                    vertical = 8.dp,
                    horizontal = 16.dp
                ),
        ) {
            Icon(
                painter = painterResource(Res.drawable.ic_sort_24),
                contentDescription = null,
                tint = contentColor,
                modifier = Modifier.size(24.dp)
            )
            AppSpacer(4.dp)
            Text(
                text = sortType.text,
                style = AppTextStyles.labelMediumMedium,
                color = contentColor
            )
        }
    }
}

val Colors.filledSortContentEnabled
    get() = if (isLight) AppColors.grayLight950 else AppColors.grayDark50

val Colors.filledSortContentFocused
    get() = if (isLight) AppColors.blue600 else AppColors.blue50

val Colors.filledSortBackgroundEnabled
    get() = if (isLight) AppColors.grayLight100 else AppColors.grayDark950

val Colors.filledSortBackgroundFocused
    get() = if (isLight) AppColors.blue100 else AppColors.blue500


@Preview
@Composable
private fun Preview() {
    Column {
        AppTheme(isDarkTheme = false) {
            Column(
                modifier = Modifier
                    .background(Color.White)
                    .padding(16.dp)
            ) {
                SortButton(sortType = SortTypeUIModel.Newest())
                AppSpacer(8.dp)
                SortButton(sortType = SortTypeUIModel.HighPrice())
                AppSpacer(8.dp)
                SortButton(sortType = SortTypeUIModel.LowPrice())
            }
        }
        AppTheme(isDarkTheme = true) {
            Column(
                modifier = Modifier
                    .background(Color.Gray)
                    .padding(16.dp)
            ) {
                AppSpacer(8.dp)
                SortButton(sortType = SortTypeUIModel.Newest())
                AppSpacer(8.dp)
                SortButton(sortType = SortTypeUIModel.HighPrice())
                AppSpacer(8.dp)
                SortButton(sortType = SortTypeUIModel.LowPrice())
            }
        }
    }
}